<template>
    <h1>Grupos de Acompanhamento para MBTs</h1>

    <DMRTrackingGroupsManagementTable 
    
    />
</template>
<script setup>
import DMRTrackingGroupsManagementTable from '../../../../../components/departments/membership/requests/tracking-groups/DMRTrackingGroupsManagementTable.vue';
</script>